<div class="container">
  <ui-toast></ui-toast>
  <app-menu class="menu"></app-menu>

  <div class="page">
    <div class="page-container">
      @if (submitted()) {
        <div class="page-message" data-testid="forgot-password-success">
          <h2 class="page-message-title">{{ 'FORGOT_PASSWORD.SUCCESS_TITLE' | transloco }}</h2>
          <p class="page-message-text">{{ 'FORGOT_PASSWORD.SUCCESS_TEXT' | transloco }}</p>
          <a class="page-message-link" data-testid="back-to-login-link" routerLink="/login">{{ 'FORGOT_PASSWORD.BACK' | transloco }}</a>
        </div>
      } @else {
        <form [formGroup]="form" (ngSubmit)="submit()">
          <h2 class="page-title" data-testid="forgot-password-title">{{ 'FORGOT_PASSWORD.TITLE' | transloco }}</h2>
          <p class="page-description">{{ 'FORGOT_PASSWORD.DESCRIPTION' | transloco }}</p>

          <div class="page-fields">
            <div class="page-fields-item">
              <div class="page-fields-item-label" data-testid="email-label">{{ 'LOGIN.EMAIL' | transloco }}</div>
              <ui-email-field
                data-testid="email-input"
                class="page-fields-item"
                formControlName="email">
              </ui-email-field>
            </div>
          </div>

          <div class="page-buttons">
            <ui-button
              data-testid="submit-btn"
              class="page-buttons-button"
              type="submit"
              [loading]="isSubmitting">
              {{ 'FORGOT_PASSWORD.SUBMIT' | transloco }}
            </ui-button>
            <a class="page-back" data-testid="back-to-login-link" routerLink="/login">{{ 'FORGOT_PASSWORD.BACK' | transloco }}</a>
          </div>
        </form>
      }
    </div>
  </div>
</div>
